import { render, staticRenderFns } from "./CheckWithLableDesc.vue?vue&type=template&id=0a9b4df8&scoped=true&"
import script from "./CheckWithLableDesc.vue?vue&type=script&lang=js&"
export * from "./CheckWithLableDesc.vue?vue&type=script&lang=js&"
import style0 from "./CheckWithLableDesc.vue?vue&type=style&index=0&id=0a9b4df8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9b4df8",
  null
  
)

export default component.exports